import React, { useEffect, useState } from 'react';
import { classnames } from 'Utils/classnames';
import Icon from 'Components/Icon';
import PropTypes from 'prop-types';
import NoSSR from 'Components/NoSSR';

export default function SelectableFilter ({ data, selectedId, onSelect, shortcutLength = 3, renderSelectPart, renderAditionalComponent, className, noWidth, scrollable }) {
  const [selections, setSelections] = useState(
    data.map((e, i)=> {
      if (i < shortcutLength) {
        e.sc = true;
      } else {
        e.sc = false;
      }
      return e;
    }
    ));

  useEffect(() => {
    const _data = data.map((e, i)=> {
      if (i < shortcutLength) {
        e.sc = true;
      } else {
        e.sc = false;
      }
      return e;
    });

    if (selectedId) { // veri geldiğinde selected zaten seçili ise, seçili olanı shortcut olarak göster
      const selectedItemIndex = _data.findIndex(e=>e.id === selectedId);
      if (selectedItemIndex > -1 && !_data[selectedItemIndex].sc) {
        const changeableScIndex = _data.map(e=>e.sc).lastIndexOf(true);
        _data[changeableScIndex] = { ..._data[changeableScIndex], sc: false };
        _data[selectedItemIndex] = { ..._data[selectedItemIndex], sc: true };
      }
    }

    setSelections(_data);
  }, [data]);

  useEffect(() => {
    if (selectedId) { // selectedId değiştiğinde, seçili olanı shortcut olarak göster
      let _data = [...selections];
      const newIndex = _data.findIndex(e => e.id === selectedId);

      if (_data[newIndex]?.sc !== true) {
        const changeableScIndex = _data.map(e=>e.sc).lastIndexOf(true);
        _data[changeableScIndex] = { ..._data[changeableScIndex], sc: false };
      }

      _data[newIndex] = { ..._data[newIndex], sc: true };
      setSelections([..._data]);
    }
  }, [selectedId]);

  const selectableFilterContainerClassnames = classnames({
    'type-input': true,
    [className]: className
  });

  function renderTypeInputSelect () {
    const unselectedItems = selections.filter(item => !item.sc);

    return (
      <div className='type-input__input'>
        <label className="type-input__input__label">
          { `+${unselectedItems.length} bahis` }
          <Icon iconName="svgDownArrow" />
        </label>

        <select
          value={ selectedId }
          className="type-select type-select--none"
          onChange={ e => {
            const { value } = e.currentTarget;
            let _data = [...selections];
            const newIndex = _data.findIndex(e => e.id === value * 1);
            onSelect && onSelect(_data[newIndex]);
          } }
        >
          { selections.map(item => (
            <option value={ item.id } key={ item.id }>{ item.description }</option>
          )) }
        </select>
      </div>
    );
  }

  return (
    <div className={ selectableFilterContainerClassnames } >
      <div className='type-input__shortcuts' >
        <NoSSR>
          { selections.filter(e =>e.sc).map(item => {
            const _class = classnames({
              'type-input__shortcuts__item': true,
              'type-input__shortcuts__item__selected': selectedId === item.id
            });
            if (item?.renderAditionalComponent) {
              return (
                <div key={ item.id } className={ _class } style={ { width: noWidth ? 'unset' : 100 / selections.filter(e=> e.sc).length + '%' } } >
                  { renderAditionalComponent() }
                </div>
              );
            }
            return (
              <div key={ item.id } className={ _class } style={ { width: noWidth ? 'unset' : 100 / selections.filter(e=> e.sc).length + '%' } } onClick={ e=>{
                if (scrollable) {
                  e.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                }
                selectedId !== item.id && onSelect && onSelect(item);
              } }>
                { item.icon ? <Icon iconName={ item.icon } /> : item.descriptionAbbr }
              </div>
            );
          }) }
        </NoSSR>
      </div>
      { renderSelectPart && renderTypeInputSelect() }
    </div>
  );
}

SelectableFilter.propTypes = {
  data: PropTypes.array.isRequired,
  selectedId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  onSelect: PropTypes.func,
  shortcutLength: PropTypes.number,
  renderSelectPart: PropTypes.bool,
  noWidth: PropTypes.bool,
  renderAditionalComponent: PropTypes.func,
  className: PropTypes.string,
  scrollable: PropTypes.bool
};
